<!-- No *ngIf here — using [class.invisible] instead so the DOM node always
     exists and Angular hydration never has to add/remove it (which causes flash).
     The space is always reserved; content appears as soon as data is available. -->
<span
  [class.invisible]="custom_ticker?.show_ticker !== 'true'"
  [innerHTML]="custom_ticker?.custom_ticker | sanitizeHtml">
</span>